import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=f0227852&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=js&"
export * from "./Experience.vue?vue&type=script&lang=js&"
import style0 from "./Experience.vue?vue&type=style&index=0&id=f0227852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0227852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0227852')) {
      api.createRecord('f0227852', component.options)
    } else {
      api.reload('f0227852', component.options)
    }
    module.hot.accept("./Experience.vue?vue&type=template&id=f0227852&scoped=true&", function () {
      api.rerender('f0227852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Experience.vue"
export default component.exports